<template>
  <div>
    <h1>Deshabilitar concesión </h1>
    <div class="card">
      <div class="card-body">
        <a-form :form="form" @submit.prevent="handleSubmit" layout="vertical">
          <div class="row">
            <div class="col-md-6">
              <label>Evidencia (adjuntar archivo .jpg, .png, .pdf)</label>
              <b-form-file
                v-model="$v.concesion.file.$model"
                ref="file"
                :state="fileState"
                placeholder="Evidencia"
                browse-text="Adjuntar"
                drop-placeholder="Drop file here..."
                @change="onFileSelected"
                required
                accept="application/pdf,image/x-png,image/gif,image/jpeg"
                ></b-form-file>
            </div>
            <div class="col-md-6">
              <a-form-item label="Motivo de baja">
                <a-input ref="name" placeholder="Motivo de baja" v-model="$v.concesion.reason.$model" />
                <small class="text-danger" v-if="!$v.concesion.reason.required">Campo requerido. No debe estar vacío.</small><br>
              </a-form-item>
            </div>
            <div class="col-12">
              <a-form-item>
                <button ref="button" type="submit" class="btn btn-light px-5" :disabled="$v.$invalid">
                  Deshabilitar
                </button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import { uploadFileS3 } from '../../../s3/s3Up.js'
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
const CREATE_CONCESION_BAN = gql`
  mutation createConcesionBan($reason: String, $fileUrl: String, $createdBy: String, $concesionId: Int){
    createConcesionBan(concesionBan: { reason: $reason fileUrl: $fileUrl createdBy: $createdBy concesionId: $concesionId }){
      id
      reason
    }
  }
`
const DELETE_CONCESION = gql`
  mutation deleteConcesion($idDelete: Int) {
      deleteConcesion(id:$idDelete){
        id
        concesionNumber
    }
  }
`
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      concesion: {
        file: null,
        reason: '',
      },
      fileState: null,
      createdBy: this.$store.state.user.email,
      concesionId: this.$route.params.id,
    }
  },
  methods: {
    onFileSelected(event) {
      this.concesion.file = event.target.files[0]
    },
    async handleSubmit() {
      const file = []
      file.fileExtension = this.concesion.file.name.split('.').pop()
      file.fileUploaded = this.concesion.file
      file.fileUploaded = this.concesion.file
      const uploadedFile = await uploadFileS3(file)

      this.$apollo.mutate({
        mutation: CREATE_CONCESION_BAN,
        context: headers(),
        variables: {
          reason: this.concesion.reason,
          createdBy: this.createdBy,
          concesionId: parseInt(this.concesionId),
          fileUrl: uploadedFile.Location,
        },
      })
        .then(data => {
          this.$apollo.mutate({
            mutation: DELETE_CONCESION,
            context: headers(),
            variables: {
              idDelete: parseInt(this.concesionId),
            },
          })
            .then(data => {
              console.log(data)
              this.$router.push({ name: 'getConcesiones' })
            })
            .catch(error => {
              console.log(error)
            })
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
  created() {
    console.log(this.$route.params)
  },
  validations: {
    concesion: {
      file: { required },
      reason: { required },
    },
  },
}
</script>
